import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearActiveObject, clearActiveObjects, clearLeftWorkAreaState, setProduct2dActivePart, setProduct2dCanvasState } from '../../../redux/actions/product2dActions';

export const useProductToggle = ()=>{
    const dispatch = useDispatch()
    const product2d = useSelector((state:any) => state.product2d)
    const makFabric = useSelector((state:any) => state.makFabric)
    const product2dActivePart = useSelector((state:any) => state.product2dActivePart)
    const product2dCanvasState = useSelector((state:any) => state.product2dCanvasState)
  
    const changeActivePart = ({target}:any) => {
      dispatch(
        setProduct2dCanvasState(
          product2dCanvasState.map((item:any) =>
            item.name === product2dActivePart.name
              ? {
                  name: item.name,
                  state: makFabric.getCanvasState(),
                }
              : item,
          ),
        ),
      )
  
      makFabric.clearCanvas()
  
      dispatch(
        setProduct2dActivePart(
          product2d.parts.find((item:any) => item.name === target.dataset.value),
        ),
      )
  
      let st = product2dCanvasState.find(
        (item:any) => item.name === target.dataset.value && item.state !== "",
      )
  
      if (st) {
        makFabric.loadCanvasState(st.state)
      }
  
      dispatch(clearLeftWorkAreaState())
      dispatch(clearActiveObject())
      dispatch(clearActiveObjects())
    }

    let currentPanelIndex = product2dCanvasState.findIndex((item:any) => item.name === product2dActivePart.name);
    let prevPanel = product2dCanvasState[currentPanelIndex-1]?.name;
    let nextPanel = product2dCanvasState[currentPanelIndex+1]?.name;

    return {
        nextPanel,
        prevPanel,
        changeActivePart,
        panels : product2dCanvasState.map((item:any)=>item.name),
    }
  
  
}